module.exports = __webpack_public_path__ + "img/rocchio-1.9bdcaae6.png";